import { HubSectionType } from 'utils/gloo-types';
import HubAuthoringSplitSection from 'pages/_AdminAuthoringPages/AdminHubAuthoring/HubAuthoringForm/HubAuthoringSplitSection';
import HubAuthoringHeader from 'pages/_AdminAuthoringPages/AdminHubAuthoring/HubAuthoringForm/HubsAuthoringHeader';
import HubSectionImageForm from 'pages/_AdminAuthoringPages/AdminHubAuthoring/HubAuthoringForm/HubSectionImageForm';
import HubSectionTextForm from 'pages/_AdminAuthoringPages/AdminHubAuthoring/HubAuthoringForm/HubSectionTextForm';
import { HubAuthoringContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { ReactNode, useContext, useEffect, useRef, useState } from 'react';
import HubSectionForm from 'pages/_AdminAuthoringPages/_components/HubSectionForm';
import HubAuthoringResourcesSectionContent from './HubAuthoringResourcesSectionContent';
import AddHubSectionButton from './AddHubSectionButton';

const HubAuthoringForm = () => {
  const {
    hubUpsertParams: { sections },
    errors,
  } = useContext(HubAuthoringContext);

  const itemToScrollTo = useRef<HTMLInputElement>(null);

  const [shouldScroll, setShouldScroll] = useState(false);

  const setShouldScrollToTrue = () => {
    setShouldScroll(true);
  };

  useEffect(() => {
    if (shouldScroll) {
      itemToScrollTo.current.focus();
      itemToScrollTo.current.scrollIntoView();
      setShouldScroll(false);
    }
  }, [shouldScroll]);

  return (
    <div>
      <HubAuthoringHeader />
      {sections.map((section, index) => {
        const sectionId = section.clientId;
        let child: ReactNode;
        switch (section.type) {
          case HubSectionType.SPLIT:
            child = <HubAuthoringSplitSection splitSection={section} index={index} errors={errors} />;
            break;
          case HubSectionType.TEXT:
            child = <HubSectionTextForm section={section} index={index} />;
            break;
          case HubSectionType.IMAGE:
            child = <HubSectionImageForm section={section} index={index} errors={errors} />;
            break;
          case HubSectionType.RESOURCE:
            child = <HubAuthoringResourcesSectionContent section={section} index={index} />;
            break;
          default: {
            console.error(`cannot render section component of type ${(section as any).type}`);
          }
        }

        const isLast = index === sections.length - 1;

        return (
          <HubSectionForm key={sectionId} index={index} isLast={isLast} innerRef={isLast ? itemToScrollTo : null}>
            {child}
          </HubSectionForm>
        );
      })}
      <div className="flex justify-center mt-5">
        <AddHubSectionButton scrollToAddedSection={setShouldScrollToTrue} />
      </div>
    </div>
  );
};

export default HubAuthoringForm;
